import {corePublicApolloClient, throwGQLErrorMessage} from '../../utils/apollo-client';
import { validateResetPassword as mutation } from '../graphql/reset-password';

export default async function resetPassword(token, password) {
  const response = await corePublicApolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: { token, password }
      })
    )
    .catch(throwGQLErrorMessage);

  return response.data.validateResetPassword;
}
